import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getPreference, setPreference } from "./preferences";

// Import translation files
import en from "./locales/en.json";
import ja from "./locales/ja.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import ko from "./locales/ko.json";
import zh from "./locales/zh.json";

// Get saved language preference or default to English
const savedLanguage = getPreference("language") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
    es: { translation: es },
    fr: { translation: fr },
    pt: { translation: pt },
    ko: { translation: ko },
    zh: { translation: zh },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

// Save language preference when it changes
i18n.on("languageChanged", (lng) => {
  setPreference("language", lng);
});

export default i18n;
